import { Highway, Parking, Tickets } from '@ui/components/icons';
import { ServiceType } from '@interfaces/models';
import React from 'react';

export const ServiceIcons: Record<ServiceType, React.ReactNode> = {
  [ServiceType.PUBLIC_TRANSPORT]: <Tickets />,
  [ServiceType.HIGHWAYS]: <Highway />,
  [ServiceType.PARKINGS]: <Parking />,
};
